var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns" }, [
    _c("div", { staticClass: "side-menu column is-2" }, [
      _c("div", { staticClass: "p-sm" }, [
        _c("ul", { staticClass: "menu-list" }, [
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  class: {
                    "is-active":
                      _vm.$route.name == "dashboard" ||
                      _vm.$route.name == "home"
                  },
                  attrs: { to: "/dashboard/unit" }
                },
                [
                  _c("b-icon", {
                    staticClass: "p-r-sm",
                    attrs: { icon: "domain", size: "is-small" }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("menu.unit")))])
                ],
                1
              ),
              _c(
                "router-link",
                { attrs: { to: "/dashboard/operator" } },
                [
                  _c("b-icon", {
                    staticClass: "p-r-sm",
                    attrs: { icon: "account-box", size: "is-small" }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("menu.operator")))])
                ],
                1
              ),
              _c(
                "router-link",
                { attrs: { to: "/dashboard/news" } },
                [
                  _c("b-icon", {
                    staticClass: "p-r-sm",
                    attrs: { icon: "newspaper", size: "is-small" }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("menu.news")))])
                ],
                1
              ),
              _c(
                "router-link",
                { attrs: { to: "/dashboard/question" } },
                [
                  _c("b-icon", {
                    staticClass: "p-r-sm",
                    attrs: { icon: "help-circle-outline", size: "is-small" }
                  }),
                  _c("span", [_vm._v(_vm._s(_vm.$t("menu.question")))])
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "column p-t-md" }, [_c("router-view")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }